import { Formik } from 'formik'
import React, { useContext, useState } from 'react'
import { match, Redirect } from 'react-router'
import * as Yup from 'yup'
import { isTokenValid } from '../../utils/auth'
import Logo from '../icons/ui/Logo'
import RegisterForm from './RegisterForm'
import { messageTypes, MessageTopBar } from '../ui/entity/MessageTopBar'
import { NotificationProvider } from '../ui/notification-provider'
import { withRouter, RouteComponentProps } from 'react-router-dom'

interface IRegister extends RouteComponentProps<any> {
  error: string | null
  isFetching: boolean
  isFetchSuccess: boolean
  registerUser: any
  match: match<any>
}

const Register = (props: IRegister) => {
  const [email, setEmail] = useState('')
  const notification: any = useContext(NotificationProvider)
  const role = props.match.params.role

  if (props.isFetchSuccess && !props.error) {
    props.history.push({
      pathname: `/auth/${email}/${role}/signupsuccess`
    })

    notification.addNotification({
      title: 'Successfully registered!',
      message: 'Please check your email.',
      level: 'success',
      autoDismiss: 10
    })
  }

  const registerSubmit = (res: any, submit: any) => {
    setEmail(res.email.emailAddress)
    props.registerUser(res, submit)
  }

  return (
    <div className='col-12 absolute top-0 bottom-0 left-0 right-0 flex flex-wrap direction-column justify-center items-center bg-green'>
      <div>
        <Logo className='margin-auto block icon--89x137' />
        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            password: '',
            username: '',
            email: {
              emailAddress: ''
            },
            phones: [],
            rolesInApp: [role]
          }}
          validationSchema={Yup.object().shape({
            firstName: Yup.string().required('First name is required'),
            lastName: Yup.string().required('Last name is required'),
            password: Yup.string().test('match', 'Should be empty', v => !v),
            username: Yup.string().required('username is required'),
            email: Yup.object().shape({
              emailAddress: Yup.string().required('Email is required')
            }),
            phones: Yup.array().min(1, 'Phone number is rquired')
          })}
          onSubmit={registerSubmit}
          render={RegisterForm}
        />
      </div>
    </div>
  )
}

export default withRouter(Register)



// WEBPACK FOOTER //
// ./src/components/authentication/Register.tsx